import React from 'react'

const Tempelate = () => {
  return (
    <>
    <div className='web-tempelate'>
      <div className='tempelate'>
        <h1>Web Tempelates</h1>
       <h2>Browse our selection of <strong>free</strong> responsive HTML Templates</h2>
       </div>
       <div className='girl-image'>
      <img src='https://www.w3schools.com/w3css_templates.webp'></img>
   </div>

<div className='tempelate-btn'>
    <div className='browse-btn'>Browse Tempelates</div>
</div>
       </div>
    </>
  );
}

export default Tempelate;